import * as Popper from "popper.js";
import * as React from 'react';
import { DatePickerWrapped } from '../datepicker-wrap/DatePickerWrap';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id                  : string;
    label               : string;
    value               : any;
    onChange            : any;
    className?          : string;
    error?              : string;
    disable?            : boolean;
    format?             : string;
    name?       : string;

    readOnly?           : boolean;
    highlightDates?     : Date[];

    maxDate?            : Date;
    minDate?            : Date;
    
    maxTime?            : Date;    
    minTime?            : Date;
    
    includeDates?       : Date[];
    excludeDates?       : Date[];
    
    includeTimes?       : Date[];
    excludeTimes?       : Date[];

    startDate?          : Date;
    endDate?            : Date;

    inline?             : boolean;
    withPortal?         : boolean;
    popperModifiers?    : Popper.Modifiers;
    placeholder?        : string;
}

// #endregion

const DateInput : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        name,
        value,
        placeholder,
        onChange,
        disable } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <DatePickerWrapped 
                dateValue={ value }
                name={ name }
                classes="form-control"
                handleChange={ onChange }
                disable={ disable }
                placeholder={ placeholder }
                {...props} />
            <InputFeedback error={error} />
        </div>
    );
};

DateInput.defaultProps = {
    className   : '',
    error       : '',
    disable     : false,
    format      : '',
    placeholder : '',
    name        : ''
};

export { DateInput };
